import ReactCurrencyInput from 'react-currency-input';

const componentDidMountSuper = ReactCurrencyInput.prototype.componentDidMount;
ReactCurrencyInput.prototype.componentDidMount = function (...args) {
  const container = this as any;
  if (!this.props.autoFocus) {
    const setSelectionRangeSuper = container.theInput.setSelectionRange;
    container.theInput.setSelectionRange = () => {};
    componentDidMountSuper?.call(this, ...args);
    container.theInput.setSelectionRange = setSelectionRangeSuper;
  } else {
    componentDidMountSuper?.call(this, ...args);
  }
};

const componentDidUpdateSuper = ReactCurrencyInput.prototype.componentDidUpdate;
ReactCurrencyInput.prototype.componentDidUpdate = function (...args) {
  const container = this as any;
  if (!this.props.autoFocus) {
    const setSelectionRangeSuper = container.theInput.setSelectionRange;
    container.theInput.setSelectionRange = () => {};
    componentDidUpdateSuper?.call(this, ...args);
    container.theInput.setSelectionRange = setSelectionRangeSuper;
  } else {
    componentDidMountSuper?.call(this);
  }
};
